module.exports = __webpack_public_path__ + "img/144.997ff79c.jpg";